import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { useHeader } from '../../../components/Header/hooks/useHeader';

export function Header(): JSX.Element {
	const { headline, description } = useHeader();

	return (
		<>
			<Box sx={{ mb: 16 }}>
				<Text data-qa="ppmu-modal-header-title" variant="heading" fontWeight="bold" as="h3" size="small">
					{headline}
				</Text>
			</Box>
			<Text data-qa="ppmu-modal-header-description" fontWeight="normal" variant="body">
				{description}
			</Text>
		</>
	);
}
